module.exports = __webpack_public_path__ + "static/profile_photo-51324a3af677f15512b9a642ced88103.jpg";